export enum TranslationKey {

    // General texts
    Important_information = 'general_important_information',
    Recaptcha_terms_conditions = 'recaptcha_terms_conditions',
    Common_email_recipient = 'global_email_recipient_instruction',
    Common_share_confirmation = 'global_share_confirmation',
    Common_ticket_information = 'global_ticket_information',
    Common_visitor_information = 'global_visitor_information',
    Common_offline_explanation = 'offline_explanation',
    General_request_error_title = 'general_request_error_title',
    Save_changes = 'm_general_save_changes',

    // Accessibility information
    Accessibility_title = 'accessibility_title',
    Accessibility_more_information = 'accessibility_readmore',

    // Titles
    Account_section_title = 'e_user_account',

    // Digital ticket
    Stored_tickets_title = 'user_stored_tickets_title',
    Digital_ticket_general_error = 'digital_ticket_share_error',
    Digital_ticket_share_ticket = 'digital_ticket_share_ticket',
    Digital_ticket_share_ui_title = 'digital_ticket_share_ui_title',
    Digital_ticket_shared_ticket_application_page_title = 'digital_ticket_shared_ticket_application_page_title',
    Digital_ticket_shared_with = 'digital_ticket_shared_with',
    Digital_ticket_recipient = 'digital_ticket_recipient',
    Digital_ticket_reclaim = 'digital_ticket_reclaim_shared_ticket',
    Digital_ticket_reclaim_error = 'digital_ticket_reclaim_error',

    // Date related translations
    Date_at_label = 'e_dates_date_at',
    Date_from_label = 'search_from',
    Date_on_label = 'e_dates_on',
    Date_to_label = 'search_to',
    Is_local_time = 'general_localtime',
    Date_label = 'main_date',
    Time_label = 'main_time',

    // Images
    Logo_alt_text = 'logo_description',

    // Add 2 home screen
    Install_cta_label = 'install_app_cta',
    Install_title = 'install_app_title',
    Install_pitch = 'install_app_pitch',

    // Event list items
    Additional_event_information = 'event_additional_event_information',
    List_button_label = 'e_ticket_tickets',
    Show_more = 'promotion_show-more',

    // FanTicket
    Fan_ticket_information = 'fan_ticket_information',

    // GDPR consent
    Consent_you_tube_video = 'consent_you_tube_video',
    Consent_user_statement = 'consent_user_statement',

    // Navigation
    Navigate_back_label = 'e_navigation_back',
    Navigate_close_label = 'm_general_close',
    Navigate_directions_label = 'e_venue_get_directions',
    Navigate_download_label = 'general_download',
    Navigate_event_details_label = 'e_event_event_details',
    Navigate_share_label = 'global_share',
    Navigation_section_artists = 'main_nav_artists',
    Navigation_section_events = 'main_nav_events',
    Navigation_section_venues = 'main_nav_venues',

    // Notices
    Empty_ticket_list_notice = 'notice_empty_ticket_list',
    Loading_notice = 'e_search_loading',
    Screen_brightness_notice = 'notice_screen_brightness',
    No_search_results_notice = 'notice_no_search_results',
    No_filtered_results_notice = 'notice_no_filtered_results',
    Notice_double_currency = 'notice_double_currency',
    Notice_invalid_email = 'register_error_email',
    Notice_own_email = 'global_email_recipient_error_own',
    Notice_prices_not_available = 'notice_prices_not_available',
    Notice_promotion_prices_not_available = 'notice_promotion_prices_not_available',

    // Notifications / push notifications
    Notifications_label = 'push_notifications_label',
    Notifications_subscribe = 'general_subscribe',
    Notifications_subscribe_hint = 'push_notifications_hint',
    Event_changes_notifications_pitch = 'push_notifications_pitch_events_bought',
    Event_changes_notifications_title = 'push_notifications_title_events_bought',
    General_notifications_pitch = 'push_notifications_pitch_general',
    General_notifications_title = 'push_notifications_title_general',

    // Offline page
    Digital_tickets_not_found_and_instructions = 'digital_tickets_not_found_notice_instructions',
    Digital_tickets_available_notice = 'digital_tickets_available_notice',

    // Promoter information
    Performance_promoter_information='e_performance_promoter_info',

    // Search & filtering
    Search = 'search_search',
    Search_artists = 'e_artists_search_favorite',
    Search_by_name = 'search_by_name',
    Search_interests = 'search_interests',
    Search_label = 'e_search_search_string',
    Filter_trigger = 'filter_label',
    Filter_date = 'searchfilter_date',
    Filter_category = 'searchfilter_category',
    Filter_country = 'searchfilter_country',
    Filter_city = 'searchfilter_city',
    More_search_results = 'm_search_more_results',
    No_search_results = 'outlets_no_results',
    Search_query_error = 'search_result',
    Filter_by = 'e_search_filter_by',
    No_filters_notice = 'search_no_filters',
    Save = 'm_general_save',
    Confirm = 'register_confirm',
    Search_submit = 'sidebar_quicksearch_submit',

    // Seatmap
    Seatmap_loading_notice = 'seatmap_wait_loading',
    Seatmap_error = 'seatmap_error',
    Seatmap_price_category_filter = 'seatmap_price-category-filter',
    Seatmap_runtime_error = 'seatmap_service_runtime_error',
    Seatmap_max_selection_error = 'seatmap_error-restriction-max-selection',
    Seatmap_max_price_level_restriction_error = 'seatmap_max_price_level_restriction_error',
    Seatmap_max_cart_error = 'seatmap_error-restriction-max-cart',
    Seatmap_min_ticket_restriction_error = 'seatmap_error-restriction-min-rebate',
    Seatmap_max_ticket_restriction_error = 'seatmap_error-restriction-max-rebate',
    Seatmap_no_seats_selected = 'seatmap_no_seats_selected',
    Seatmap_seats_selected_amount = 'seatmap_seats_selected_amount',
    Seatmap_step_ticket_restriction_error = 'seatmap_error-restriction-step',
    Seatmap_label = 'e_performance_seatmap',
    Seatmap_exit_seatmap_selection = 'seatmap_exit_seatmap_selection',
    Seatmap_tickets_unavailable = 'seatmap_error-tickets-unavailable',
    Seatmap_seat_unavailable = 'seatmap_error-seat-unavailable',
    Seatmap_general_admission_unavailable = 'seatmap_error-general-admission-unavailable',
    Seatmap_select_promotion = 'seatmap_warning-select-promotion',
    Seatmap_select_tickets = 'seatmap_select-tickets',
    Seatmap_action_info = 'seatmap_action_info',
    Seatmap_action_promo = 'seatmap_action_promo',
    Seatmap_action_filter = 'seatmap_action_filter',

    // TDL promotions
    Promotion_interface_title = 'promotion_interface_title',
    Promotion_interface_subtitle = 'promotion_interface_subtitle',
    Promotion_select_campaign = 'promotions_promotion_select_campaign',
    Promotion_enter_code_placeholder = 'promotions_enter_promotion_code_placeholder',
    Promotion_apply_promotion = 'promotions_apply_promotion',
    Promotion_selected_promotion_interface_title = 'promotion_selected_promotion_interface_title',
    Promotion_selected_promotion_interface_subtitle = 'promotion_selected_promotion_interface_subtitle',
    Promotion_error_not_selected = 'promotion_error_not_selected',
    Promotion_error_not_entered = 'promotion_error_not_entered',
    Promotion_error_code_disabled = 'promotions_error_codedisabled',
    Promotion_error_code_invalid = 'promotions_error_codeinvalid',
    Promotion_error_code_used_up = 'promotions_error_codeusedup',
    Promotions_error_ws_error = 'promotions_error_ws_error',

    // Ticket selection translations
    Seatmap_trigger = 'seatmap_seatmap_trigger',
    Seatmap_trigger_detail = 'seatmap_seatmap_trigger_detail',
    Bestseat_trigger = 'seatmap_best_seat_trigger',
    Bestseat_trigger_detail = 'seatmap_best_seat_trigger_detail',
    Reservation_notice_voucher = 'voucher_reserve_notice',
    Reservation_notice_common = 'buy_note',
    Ticket_selection_show_all_prices_label = 'ticket_selection_show_all_prices_label',
    Ticket_selection_start_price_label = 'ticket_selection_start_price_label',
    Ticket_selection_single_type_selection_heading = 'ticket_selection_single_type_selection_heading',
    Ticket_selection_ticket_count_submit = 'ticket_selection_ticket_count_submit',
    Ticket_selection_min_ticket_type = 'ticket_selection_min_ticket_type_error',
    Ticket_fees = 'common_ticket_fees',
    Ticket_fee_pitch = 'ticket_fee_pitch',
    Ticket_fee_description = 'ticket_fee_description',
    Ticket_total = 'common_total',

    // Ticket information
    Entrance_label = 'seatmap_entrance',
    General_admission = 'basket_general_admission',
    Row_label = 'e_ticket_row',
    Seat_label = 'e_ticket_seat',
    Seating_info_label = 'label_seating_info',
    Visitor_id_label = 'my_account_id_number',

    // Main Header
    Mainmenu_events = 'main_nav_events',
    Events_all = 'dropdown_all-events',
    Dropdown_all = 'dropdown_all',
    Login = 'login_title',
    Logout = 'e_user_logout',

    // Interest subscription
    Interest_subscription_general_interest_name = 'interest_subscription_general_interest_name',
    Interest_subscription_general_interest_title = 'interest_subscription_general_interest_title',
    Interest_subscription_general_interest_description = 'interest_subscription_general_interest_description',
    Interest_subscription_general_success_title = 'interest_subscription_general_success_title',
    Interest_subscription_special_interest_name = 'interest_subscription_special_interest_name',
    Interest_subscription_special_interest_description = 'interest_subscription_special_interest_description',
    Interest_subscription_success_title = 'interest_subscription_subscription_success_title',
    Interest_subscription_success_description = 'interest_subscription_subscription_success_description',
    Interest_subscription_category_interest_title = 'interest_subscription_category_interest_title',
    Interest_subscription_category_interest_description = 'interest_subscription_category_interest_description',
    Interest_subscription_artist_interest_title = 'interest_subscription_artist_interest_title',
    Interest_subscription_artist_interest_description = 'interest_subscription_artist_interest_description',
    Interest_subscription_venue_interest_title = 'interest_subscription_venue_interest_title',
    Interest_subscription_venue_interest_description = 'interest_subscription_venue_interest_description',
    Interest_subscription_error = 'interest_subscription_subscription_error',
    Interest_subscription_email_sent = 'newsletter_email_sent',


    Interest_subscription_general_interest_section_title = 'interest_subscription_general_interest_section_title',
    Interest_subscription_general_interest_section_description = 'interest_subscription_general_interest_section_description',
    Interest_subscription_topics_section_title = 'interest_subscription_topics_section_title',
    Interest_subscription_topics_section_description = 'interest_subscription_topics_section_description',
    Interest_subscription_artist_section_title = 'common_artist_alarm_category',
    Interest_subscription_artist_section_description = 'e_artist_ticketalarm_up_to_date',
    Interest_subscription_select_type = 'interest_subscription_select_type',
    Interest_subscription_limit_by_name = 'interest_subscription_limit_by_name',
    Interest_subscription_authentication_error = 'interest_subscription_authentication_error',

    // User related
    User_enter_your_email = 'e_user_your_email',
    Customer_no_contact_title = 'customer_no_contact_title',
    Customer_no_contact_description = 'customer_no_contact_description',

    //Cookie management
    Cookie_group_error_selection = 'cookie_group_error_selection',
    Cookie_group_title_necessary = 'cookie_group_title_necessary',
    Cookie_group_title_functional = 'cookie_group_title_functional',
    Cookie_group_title_advertisment = 'cookie_group_title_advertisment',
    Cookie_group_title_social = 'cookie_group_title_social',
    Cookie_group_title_ad_user_data = 'cookie_group_title_ad_user_data',
    Cookie_group_title_ad_personalization = 'cookie_group_title_ad_personalization',
    Cookie_group_description_ad_user_data = 'cookie_group_description_ad_user_data',
    Cookie_group_description_ad_personalization = 'cookie_group_description_ad_personalization',
    Cookie_group_description_social = 'cookie_group_description_social',
    Cookie_group_description_necessary = 'cookie_group_description_necessary',
    Cookie_group_description_functional = 'cookie_group_description_functional',
    Cookie_group_description_advertisment = 'cookie_group_description_advertisment',
    Cookie_group_option_enable = 'cookie_group_option_enable',
    Cookie_group_option_disable = 'cookie_group_option_disable',
    Cookie_group_text_enabled_by_default = 'cookie_group_text_enabled_by_default',
}
